import { WatchAccountService } from '../../../services/watch-account.service';
import { AccountService } from '../../../services/account.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'modal-add-funnel-step',
  template: require('./modal-add-funnel-step.component.pug'),
  styles: [require('./modal-add-funnel-step.component.css').toString()],
})
export class ModalAddFunnelStepComponent implements OnInit {
  form: FormGroup;
  sharing: number = 0;
  reason = new Subject<number>();

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    fb: FormBuilder,
    private account_service: AccountService,
    private watch_account: WatchAccountService,
    private router: Router,
  ) {
    this.form = fb.group({
      name: ['', Validators.required],
    });
  }

  // -------------------------------------------------------------------
  ngOnInit() {}

  // -------------------------------------------------------------------
  setPrivacy(privacy: number) {
    this.sharing = privacy;
  }

  // -------------------------------------------------------------------
  getPrivacy() {
    return this.sharing;
  }

  // -------------------------------------------------------------------
  getName() {
    return this.form.get('name').value;
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.reason.next(null);
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  setOption(option) {
    this.reason.next(option);
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    let account_id = this.watch_account.accountId().getValue();

    this.account_service.createFunnel(
      account_id,
      this.getName(),
      this.sharing,
      res => {
        this.router.navigate([
          '/account/' +
            account_id +
            '/funnels/' +
            res.funnelId.toString() +
            '/steps',
        ]);
        this.bsModalRef.hide();
        //onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
}

console.log('permissions');

//     button.btn.btn-primary([disabled]='!getName()', (click)='create(false)') Create Funnel
